import { Component } from '@angular/core';
import { StorageService } from '../../core/storage/storageService';
import { MerchantService } from '../../models/merchant/merchantService';
import { environment } from '../../../environments/environment';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { IconType } from '../../../../../../libs/Shared/components/icon/icon';

@Component({
  selector: 'app-merchant-layout',
  templateUrl: './merchant-layout.component.html',
  standalone: false,
})
export class MerchantLayoutComponent {
  IconType = IconType;
  constructor(
    public storage: StorageService,
    private http: HttpClient,
  ) {
    storage.setShowSupportInfo(storage.getSelectedLocation() != undefined);
  }

  downloadTokenizationWidget() {
    this.http
      .get(`${environment.apiUrl}/widget`, { responseType: 'blob' })
      .subscribe((response: Blob) => {
        saveAs(response, 'tokenization-widget.js');
      });
  }
}
